export const MediaType = {
  image: 0,
  video: 1,
};
